import { SelectOption } from '@doveit/bricks';
import { IntentStatus } from '../../../domain/types';
import { intentStatusLabels } from '../../../labels';

const koReasonOptions = [
  IntentStatus.KO_INFO,
  IntentStatus.KO_PROPERTY,
  IntentStatus.KO_AREA,
  IntentStatus.KO_OVERPRICED,
  IntentStatus.KO_BOUGHT_OTHER,
  IntentStatus.KO_NOT_INTERESTED,
];

const koPropertyInProposalReasonOptions = [
  ...koReasonOptions,
  IntentStatus.KO_PROPERTY_NOT_AVAILABLE,
];

const koOfferRefusedReasonOptions = [
  IntentStatus.KO_OVERPRICED,
  IntentStatus.KO_BOUGHT_OTHER,
];

export function computeKoReasonOptions(hasRefusedOffer: boolean, isPropertyInProposal: boolean): SelectOption[] {
  let reasonOptions = null;
  if (hasRefusedOffer) {
    reasonOptions = koOfferRefusedReasonOptions;
  } else if (isPropertyInProposal) {
    reasonOptions = koPropertyInProposalReasonOptions;
  } else {
    reasonOptions = koReasonOptions;
  }
  return [
    {
      value: '',
      label: 'Seleziona una motivazione',
    },
    ...reasonOptions.map((key) => ({
      value: key,
      label: intentStatusLabels[key as IntentStatus],
    })),
  ];
}
